import { logError } from '@/src/logger';
import { track } from '@/src/utils/tracking';
import { getScreenName } from './utilsTracking';

const filtersShown = (
  businessType,
  filtersSelectedBefore,
  listedInfo,
  landingType,
  isItemLanding = false,
) => {
  const EVENT_NAME = 'filters.shown';

  try {
    const payload = {
      businessType,
      filtersSelectedBefore,
      listedInfo,
      origin: 'shop_list',
      screenName: getScreenName(landingType),
      screenType: isItemLanding ? 'items_landing' : 'vendors_landing',
    };
    track(EVENT_NAME, payload, {
      logEventKey: `[${EVENT_NAME}]`,
      sendToLogs: true,
    });
  } catch (e) {
    logError(EVENT_NAME, e);
  }
};

export default filtersShown;
